import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';

const FieldModal = ({ isOpen, toggle, editingField, formData, setFormData, onSubmit }) => {
  const [options, setOptions] = useState(formData.fieldConfig?.options || []);

  const handleAddOption = () => {
    const newOptions = [...options, { value: '', label: '' }];
    setOptions(newOptions);
    setFormData({
      ...formData,
      fieldConfig: { ...formData.fieldConfig, options: newOptions }
    });
  };

  const handleRemoveOption = (index) => {
    const newOptions = options.filter((_, idx) => idx !== index);
    setOptions(newOptions);
    setFormData({
      ...formData,
      fieldConfig: { ...formData.fieldConfig, options: newOptions }
    });
  };

  const handleOptionChange = (index, field, value) => {
    const newOptions = [...options];
    newOptions[index][field] = value;
    setOptions(newOptions);
    setFormData({
      ...formData,
      fieldConfig: { ...formData.fieldConfig, options: newOptions }
    });
  };

  const showOptions = ['select', 'checkbox', 'radio'].includes(formData.fieldType);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {editingField ? 'Chỉnh sửa Field' : 'Tạo Field Mới'}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Field Name *</Label>
                <Input
                  type="text"
                  value={formData.fieldName}
                  onChange={(e) => setFormData({...formData, fieldName: e.target.value})}
                  placeholder="fullName"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Field Label *</Label>
                <Input
                  type="text"
                  value={formData.fieldLabel}
                  onChange={(e) => setFormData({...formData, fieldLabel: e.target.value})}
                  placeholder="Họ và tên"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Field Type *</Label>
                <Input
                  type="select"
                  value={formData.fieldType}
                  onChange={(e) => {
                    setFormData({...formData, fieldType: e.target.value});
                    if (!['select', 'checkbox', 'radio'].includes(e.target.value)) {
                      setOptions([]);
                    }
                  }}
                  required
                >
                  <option value="text">Text</option>
                  <option value="email">Email</option>
                  <option value="number">Number</option>
                  <option value="tel">Phone</option>
                  <option value="textarea">Textarea</option>
                  <option value="select">Select</option>
                  <option value="checkbox">Checkbox</option>
                  <option value="radio">Radio</option>
                  <option value="date">Date</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Field Order *</Label>
                <Input
                  type="number"
                  value={formData.fieldOrder}
                  onChange={(e) => setFormData({...formData, fieldOrder: parseInt(e.target.value)})}
                  min="1"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Placeholder</Label>
                <Input
                  type="text"
                  value={formData.fieldConfig?.placeholder || ''}
                  onChange={(e) => setFormData({
                    ...formData,
                    fieldConfig: { ...formData.fieldConfig, placeholder: e.target.value }
                  })}
                  placeholder="Enter placeholder text..."
                />
              </FormGroup>
            </Col>

            {/* Options for select/checkbox/radio */}
            {showOptions && (
              <Col md="12">
                <FormGroup>
                  <Label>Options</Label>
                  {options.map((option, index) => (
                    <div key={index} className="d-flex gap-2 mb-2">
                      <Input
                        type="text"
                        placeholder="Value"
                        value={option.value}
                        onChange={(e) => handleOptionChange(index, 'value', e.target.value)}
                      />
                      <Input
                        type="text"
                        placeholder="Label"
                        value={option.label}
                        onChange={(e) => handleOptionChange(index, 'label', e.target.value)}
                      />
                      <Button 
                        color="danger" 
                        size="sm"
                        onClick={() => handleRemoveOption(index)}
                      >
                        <i className="fa fa-trash"></i>
                      </Button>
                    </div>
                  ))}
                  <Button color="success" size="sm" onClick={handleAddOption}>
                    <i className="fa fa-plus me-1"></i>
                    Add Option
                  </Button>
                </FormGroup>
              </Col>
            )}

            <Col md="6">
              <FormGroup>
                <Label>Min Length</Label>
                <Input
                  type="number"
                  value={formData.fieldConfig?.minLength || ''}
                  onChange={(e) => setFormData({
                    ...formData,
                    fieldConfig: { ...formData.fieldConfig, minLength: parseInt(e.target.value) }
                  })}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Max Length</Label>
                <Input
                  type="number"
                  value={formData.fieldConfig?.maxLength || ''}
                  onChange={(e) => setFormData({
                    ...formData,
                    fieldConfig: { ...formData.fieldConfig, maxLength: parseInt(e.target.value) }
                  })}
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label className="d-block">Options</Label>
                <div className="d-flex gap-3">
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      checked={formData.isRequired}
                      onChange={(e) => setFormData({...formData, isRequired: e.target.checked})}
                    />
                    <Label className="form-check-label">Required</Label>
                  </div>
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      checked={formData.isActive}
                      onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                    />
                    <Label className="form-check-label">Active</Label>
                  </div>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" type="submit">
            <i className="fa fa-save me-2"></i>
            {editingField ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default FieldModal;

